import React from 'react';
import RoofCalculatorForm from './components/PriceCalculatorForm';
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';

function App() {
    return (
        <CacheBuster
            currentVersion={packageJson.version}
            isEnabled={true}
            isVerboseMode={false}
        >
            <div className="App">
                <RoofCalculatorForm />
            </div>
        </CacheBuster>
    );
}

export default App;